import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from 'src/app/shared/services/config.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { MockAPIProvider } from 'src/app/shared/services/mock-api.provider';

import { Jumbotron } from 'ascedia-design-system/lib/models/jumbotron.interface';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

	public jumbotron$: Observable<Jumbotron>;
	public taBody$: Observable<any>;

	constructor(
		private _mockAPIProvider: MockAPIProvider,
		private _configService: ConfigService,
		private _metaService: MetaService,
	) { }

	ngOnInit(): void {
		this._metaService.updateMetaData('Privacy');

		this.jumbotron$ = this._mockAPIProvider.load('main/privacy-jumbotron.json', false)
			.pipe(map((res: Jumbotron) => {
				//console.log('jumbotron$:', res);
				if(res) {
					//console.log('jumbotron:', res);
					return res;
				}
				return null;
			}));

		this.taBody$ = this._mockAPIProvider.load('main/privacy-body.json', false)
			.pipe(map((res: any) => {
				//console.log('taBody$:', res);
				if(res) {
					//console.log('taBody:', res);
					return res;
				}
				return null;
			}));
	}

}
